export default __webpack_public_path__ + "static/media/sidebar-banner.ec070872.png";